import modal from '@/utils/modal.js';

import LootCratesListModal from './LootCratesListModal.vue';

function createLootCratesModal() {
  const m = modal.create(LootCratesListModal, true, { persistent: false });
  m.body.classList.add('gmf-loot-crate-list');
}

export default createLootCratesModal;